/* EmojiPickerFooter.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./EmojiPickerFooter.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { memo } from 'react';
import { N30A } from '@atlaskit/theme/colors';
import { EmojiPreviewComponent } from '../common/EmojiPreviewComponent';
var emojiPickerFooter = null;
var emojiPickerFooterWithTopShadow = null;
export var emojiPickerFooterTestId = 'emoji-picker-footer';
var EmojiPickerFooter = function EmojiPickerFooter(_ref) {
  var selectedEmoji = _ref.selectedEmoji;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": emojiPickerFooterTestId,
    className: ax(["_16jlidpf _1o9zidpf _i0dl1wug", "_x3do1syp _16qs2hsd"]),
    style: {
      "--_10k8kuu": ix("var(--ds-border-width-selected, 2px)".concat(" solid ", "var(--ds-border, ".concat(N30A, ")")))
    }
  }, selectedEmoji && /*#__PURE__*/React.createElement(EmojiPreviewComponent, {
    emoji: selectedEmoji
  }));
};
export default /*#__PURE__*/memo(EmojiPickerFooter);